var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"anchor",class:_vm.classAnchor,on:{"click":_vm.handleClick}},[(_vm.icon)?_c('icon',{class:_vm.icon,attrs:{"name":_vm.iconName,"size":_vm.iconSize}}):_vm._e(),_vm._t("default"),_vm._t("separator")],2)}
var staticRenderFns = []

export { render, staticRenderFns }